import { HOUSING_FORM_FEATURES } from '@schema/featureToggle'

export const housingFormTabs = HOUSING_FORM_FEATURES

export const housingFormTabsQueryParamName = 'tab'
